import {
  Box,
  DismissFilledIcon,
  Flex,
  ReadMore,
  Typography,
  useDesktopMediaQuery,
  useMobileMediaQuery,
} from '@iheartjane/reefer';
import type { PaddingProperties } from '@iheartjane/reefer';

import { useSearchContext } from '@jane/search/hooks';

interface MenuTitleProps extends PaddingProperties {
  description?: string;
  title?: string;
  variant?: 'default' | 'gold';
}

export const MenuTitle = ({
  variant = 'default',
  title,
  description,
  ...props
}: MenuTitleProps) => {
  const isMobile = useMobileMediaQuery({});
  const isDesktop = useDesktopMediaQuery({});

  const noTitle = variant === 'default' && !title;

  const {
    searchState: { searchText },
    setSearchState,
  } = useSearchContext();

  const handleClearQuery = () => {
    setSearchState({ searchText: '' });
  };

  const searchTextPadding = {
    pt: !noTitle ? (isMobile ? 24 : 48) : 0,
    pb: noTitle ? (isMobile ? 24 : 48) : 0,

    ...(variant === 'gold' && {
      pt: 0,
      pb: 24,
    }),
  } as { pb: PaddingProperties['pb']; pt: PaddingProperties['pt'] };

  return (
    <Box {...props}>
      {variant === 'default' && (
        <>
          {!!title && (
            <Typography as="h2" branded variant="h1-semibold">
              {title}
            </Typography>
          )}

          {!!description && (
            <Typography as="div" pt={isDesktop ? 8 : 4}>
              <ReadMore
                characters={isMobile ? 100 : isDesktop ? 300 : 200}
                content={description}
                more="View more"
                less="View less"
              />
            </Typography>
          )}
        </>
      )}

      {!!searchText && (
        <Flex alignItems="center" {...searchTextPadding}>
          <Typography as="h2" branded variant="h2-semibold" mr={8}>
            Search for &#34;{searchText}&#34;
          </Typography>
          <DismissFilledIcon
            onClick={handleClearQuery}
            altText="Clear search"
            size="md"
          />
        </Flex>
      )}
    </Box>
  );
};
